import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { purchaseOrderReducer } from "./PurchaseOrder";
import AddressDropdownReducer from "./AddressDropdown";
import { salesOrderReducer } from "./ConfirmSalesOrders";
import { userReducer } from "./User";
import { offlinestoreReducer } from "./OfflineStore";

const exportReducers = (history) => {
  return combineReducers({
    router: connectRouter(history),
    userReducer: userReducer,
    offlinestoreReducer:offlinestoreReducer,
    purchaseOrderReducer: purchaseOrderReducer,
    addressDropdown: AddressDropdownReducer,
    salesOrderReducer: salesOrderReducer,
  });
};

export default exportReducers;
